// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__1qQq9","left":"StickyBox_left__bLcVr","right":"StickyBox_right__3kuZa"};